import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { DialogCloseButton } from "../misc/DialogCloseButton";

export function InkassoBlockingDialog(props: { open: boolean; onClose: () => void }) {
  const { open, onClose } = props;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Deaktivierung nicht möglich</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Typography sx={{ mt: 1 }}>
          Dieser Fahrschüler befindet sich bereits im Inkasso-Verfahren und kann nicht deaktiviert werden.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Verstanden
        </Button>
      </DialogActions>
    </Dialog>
  );
}
